"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredColumnTree = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _style = _interopRequireDefault(require("./style.css"));
var _index = require("../Condition/index.js");
var _index2 = require("../../index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getFilteredColumnTree = function getFilteredColumnTree(search, columnTree) {
  var result = (0, _cloneDeep2["default"])(columnTree);
  search = search.toLowerCase();
  function filterTree(node) {
    if (node.children) {
      node.children = node.children.filter(filterTree);
      return node.children.length > 0;
    }
    return node.label.toLowerCase().includes(search);
  }
  return result.filter(filterTree);
};
exports.getFilteredColumnTree = getFilteredColumnTree;
var Component = function Component(props) {
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var columnTree = (0, _react.useContext)(_index2.ColumnTreeContext);
  var filteredTree = (0, _react.useMemo)(function () {
    return getFilteredColumnTree(search, columnTree);
  }, [search, columnTree]);
  var toggleExpanded = function toggleExpanded(value) {
    setExpanded((0, _xor2["default"])(expanded, [value]));
  };
  var traverse = function traverse(node) {
    if (node.children) {
      var isExpanded = expanded.includes(node.id) || !!search;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].header,
        onClick: function onClick() {
          return toggleExpanded(node.id);
        }
      }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
        spaceRight: true
      }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
        spaceRight: true
      }), node.label), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].level
      }, node.children.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: child.id
        }, traverse(child));
      })));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "radio",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      name: "column",
      value: node.id,
      checked: node.id === props.selectedColumn,
      onChange: function onChange(e) {
        props.onSubmit(node);
        props.closeModal();
      },
      disabled: !(node.type in _index.allConditions)
    }), node.label));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: "search",
    className: "form-control",
    placeholder: "search",
    style: {
      width: '10em'
    },
    autoFocus: true,
    autoComplete: "off",
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    }
  })), filteredTree.length === 0 ? 'No column found' : filteredTree.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.id
    }, traverse(item));
  }));
};
Component.propTypes = {
  selectedColumn: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func
};
Component.defaultProps = {
  selectedColumn: ''
};
var _default = Component;
exports["default"] = _default;